<div class="flex flex-col space-y-2">
  <h3 class="font-semibold">{{ title() }}</h3>
  <div
    class="w-full h-[var(--area-chart-height)]"
    echarts
    [options]="options()"
    (chartInit)="onChartInit($event)"></div>
</div>
